import React from 'react';
import { Paper, Typography, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

type Props = { rows?: any[] };

class SensitivityTable extends React.PureComponent<Props> {
  render() {
    const { rows = [] } = this.props;
    return (
      <Paper elevation={1} sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>Sensitivity Ranking</Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Driver</TableCell>
              <TableCell>Flow</TableCell>
              <TableCell align="right">Weight</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r, i) => (
              <TableRow key={`${r.drivercode}-${i}`}>
                <TableCell>{r.driver || r.drivername || r.drivercode}</TableCell>
                <TableCell>{r.flow || r.flowcode || '-'}</TableCell>
                <TableCell align="right">{Number(r.sensitivityweight || r.absoluteimpact || 0).toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

export default SensitivityTable;
